
define('hbs!app/editor/ColumnMenuView.hbs',['hbs','handlebars'], function(hbs, Handlebars){var t = Handlebars.template({"1":function(depth0,helpers,partials,data) {
    var stack1;

  return "		"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.hasAggregation : depth0),{"name":"if","hash":{},"fn":this.program(2, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n		"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.hasAggregation : depth0),{"name":"unless","hash":{},"fn":this.program(4, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n		"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isDimension : depth0),{"name":"if","hash":{},"fn":this.program(6, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n		"
    + ((stack1 = helpers.unless.call(depth0,(depth0 != null ? depth0.isDimension : depth0),{"name":"unless","hash":{},"fn":this.program(8, data, 0),"inverse":this.noop,"data":data})) != null ? stack1 : "")
    + "\n";
},"2":function(depth0,helpers,partials,data) {
    return "<li class=\"menu-group\" data-qa=\"menu-group\">Group</li>";
},"4":function(depth0,helpers,partials,data) {
    return "<li class=\"menu-aggregate\" data-qa=\"menu-aggregate\">Aggregate</li>";
},"6":function(depth0,helpers,partials,data) {
    return "<li class=\"menu-dimension\" data-qa=\"menu-dimension\">Dimension</li>";
},"8":function(depth0,helpers,partials,data) {
    return "<li class=\"menu-measure\" data-qa=\"menu-measure\">Measure</li>";
},"10":function(depth0,helpers,partials,data) {
    return "		<li class=\"menu-group\" data-qa=\"menu-group\">Group</li>\n		<li class=\"menu-aggregate\" data-qa=\"menu-aggregate\">Aggregate</li>\n";
},"compiler":[6,">= 2.0.0-beta.1"],"main":function(depth0,helpers,partials,data) {
    var stack1;

  return "<ul>\n"
    + ((stack1 = helpers['if'].call(depth0,(depth0 != null ? depth0.isGroupedAndAggregated : depth0),{"name":"if","hash":{},"fn":this.program(1, data, 0),"inverse":this.program(10, data, 0),"data":data})) != null ? stack1 : "")
    + "	<li class=\"menu-filter\" data-qa=\"menu-filter\">Filter by...</li>\n</ul>";
},"useData":true});Handlebars.registerPartial('app/editor/ColumnMenuView.hbs', t);return t;});
